import { useSelector, useDispatch } from 'react-redux';
import { addValidationErrorIfNeeded, removeValidationErrorIfNeeded
// @ts-expect-error untyped dependency
} from 'FormsUI/actions/FormDefinition';
import { getFallbackRouteValidation, getConditionalRouteValidation, getRoutingFieldValidation, getRoutingConditionValidation
// @ts-expect-error untyped dependency
} from 'FormsUI/selectors/FormDefinition';
import { TabValidationsKeys, ValidationKeys, ValidationType } from 'FormsUI/constants/FormFieldValidations';
const useRoutingValidation = () => {
  const dispatch = useDispatch();
  const defaultSchedulingPageValidation = useSelector(getFallbackRouteValidation);
  const conditionalSchedulingPageValidation = useSelector(getConditionalRouteValidation);
  const routingFieldValidation = useSelector(getRoutingFieldValidation);
  const routingConditionValidation = useSelector(getRoutingConditionValidation);
  const isDefaultSchedulingPageMissing = defaultSchedulingPageValidation && defaultSchedulingPageValidation[ValidationType.REQUIRED];
  const isConditionalSchedulingPageMissing = conditionalSchedulingPageValidation && conditionalSchedulingPageValidation[ValidationType.REQUIRED];
  const isRoutingFieldMissing = routingFieldValidation && routingFieldValidation[ValidationType.REQUIRED];
  const isRoutingConditionMissing = routingConditionValidation && routingConditionValidation[ValidationType.REQUIRED];
  const addFallbackRouteValidationError = () => {
    dispatch(addValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.FALLBACK_ROUTE, ValidationType.REQUIRED));
  };
  const removeFallbackRouteValidationError = () => {
    dispatch(removeValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.FALLBACK_ROUTE, ValidationType.REQUIRED));
  };
  const addConditionalRouteValueValidation = () => {
    dispatch(addValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.CONDITIONAL_ROUTE, ValidationType.REQUIRED));
  };
  const removeConditionalRouteValueValidation = () => {
    dispatch(removeValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.CONDITIONAL_ROUTE, ValidationType.REQUIRED));
  };
  const addFieldValidationError = () => {
    dispatch(addValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.ROUTING_FIELD, ValidationType.REQUIRED));
  };
  const removeFieldValidationError = () => {
    dispatch(removeValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.ROUTING_FIELD, ValidationType.REQUIRED));
  };
  const addConditionValidationError = () => {
    dispatch(addValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.ROUTING_CONDITION, ValidationType.REQUIRED));
  };
  const removeConditionValidationError = () => {
    dispatch(removeValidationErrorIfNeeded(TabValidationsKeys.OPTIONS, ValidationKeys.ROUTING_CONDITION, ValidationType.REQUIRED));
  };
  const addSimpleRouteValidation = () => {
    addFallbackRouteValidationError();
    removeConditionalRouteValueValidation();
    removeFieldValidationError();
    removeConditionValidationError();
  };
  const addConditionalRouteValidation = () => {
    addConditionalRouteValueValidation();
    addFieldValidationError();
    addConditionValidationError();
    removeFallbackRouteValidationError();
  };
  const removeAllValidation = () => {
    removeFieldValidationError();
    removeConditionalRouteValueValidation();
    removeFallbackRouteValidationError();
    removeConditionValidationError();
  };
  return {
    addSimpleRouteValidation,
    removeAllValidation,
    addConditionalRouteValidation,
    addFallbackRouteValidationError,
    removeFallbackRouteValidationError,
    addConditionalRouteValueValidation,
    removeConditionalRouteValueValidation,
    addFieldValidationError,
    removeFieldValidationError,
    addConditionValidationError,
    removeConditionValidationError,
    isDefaultSchedulingPageMissing,
    isConditionalSchedulingPageMissing,
    isRoutingFieldMissing,
    isRoutingConditionMissing
  };
};
export default useRoutingValidation;